'use strict';

(function ($) {
  var methods = {
    init: function (options) {
      var opts = $.extend({}, $.fn.k2_top.defaults, options);

      var containerIDhash = '#' + opts.containerID;

      $('body').append('<a href="#" id="' + opts.containerID + '" class="' + opts.containerClass + '" >' + opts.text + '</a>');

      $(containerIDhash).hide().click(function () {
        $('html, body').stop().animate({ scrollTop: 0 }, opts.scrollSpeed, opts.easingType);
        $('#' + opts.containerHoverID, this).stop().animate({ opacity: 0 }, opts.inDelay, opts.easingType);
        return false;
      });

      $(window).scroll(function () {
        var sd = $(window).scrollTop();
        if (typeof document.body.style.maxHeight === 'undefined') {
          $(containerIDhash).css({
            position: 'absolute',
            top: $(window).scrollTop() + $(window).height() - 50
          });
        }

        if (sd > opts.min) {
          $(containerIDhash).stop(true, true).fadeIn(600);
        } else {
          $(containerIDhash).fadeOut(800);
        }
      });
    }
  };

  $.fn.k2_top = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_top');
    }

  };

  $.fn.k2_top.defaults = {
    text: '<span class="glyphicon glyphicon-chevron-up"></span>',
    min: 150,
    scrollSpeed: 800,
    containerID: 'toTop',
    containerClass: 'toTop',
    easingType: 'linear'
  };

})(jQuery);
